import { classes, pages } from '../shared/labels';

export interface NavigationItem {
  label: string; // La stringa da visualizzare
  class: string;
  route?: string; // Opzionale: il percorso per il routing
  icon_path?: string;
}

export const navigationItemsNoPatient: NavigationItem[] = [
  {
    label: pages.calendar,
    class: classes.nhb,
    route: '/calendario',
    icon_path: 'assets/imgs/icons/calendario.svg',
  },
  {
    label: pages.patients_list,
    class: classes.nhb,
    route: '/pazienti',
    icon_path: 'assets/imgs/icons/pazienti.svg',
  },
  {
    label: pages.modules,
    class: classes.nhb,
    route: '/documenti',
    icon_path: 'assets/imgs/icons/documenti.svg',
  },
  {
    label: pages.invoices,
    class: classes.nhb,
    route: '/fatture',
    icon_path: 'assets/imgs/icons/fatture.svg',
  },
  {
    label: pages.aiAnalyses,
    class: classes.nhb,
    route: '/analisi-ai',
    icon_path: 'assets/imgs/icons/analisi_ai.svg',
  },
];

export const navigationItemsInvoices: NavigationItem[] = [
  {
    label: pages.calendar,
    class: classes.nhb,
    route: '/calendario',
    icon_path: 'assets/imgs/icons/calendario.svg',
  },
  {
    label: pages.patients_list,
    class: classes.nhb,
    route: '/pazienti',
    icon_path: 'assets/imgs/icons/pazienti.svg',
  },
  {
    label: pages.modules,
    class: classes.nhb,
    route: '/documenti',
    icon_path: 'assets/imgs/icons/documenti.svg',
  },
  {
    label: pages.invoices,
    class: classes.hb,
    route: '/fatture',
    icon_path: 'assets/imgs/icons/fatture.svg',
  },
  {
    label: pages.invoices_billing_data,
    class: classes.nhnb,
    route: '/fatture/dati-fatturazione',
    icon_path: 'assets/imgs/icons/identification.svg',
  },
  {
    label: pages.invoices_sales,
    class: classes.nhnb,
    route: '/fatture/fatturato',
    icon_path: 'assets/imgs/icons/queue_list.svg',
  },
  {
    label: pages.invoices_list,
    class: classes.nhnb,
    route: '/fatture',
    icon_path: 'assets/imgs/icons/numbered_list.svg',
  },
  {
    label: pages.invoices_received,
    class: classes.nhnb,
    route: '/fatture/ricevute',
    icon_path: 'assets/imgs/icons/numbered_list.svg',
  },
  {
    label: pages.client_list,
    class: classes.nhnb,
    route: '/fatture/clienti',
    icon_path: 'assets/imgs/icons/queue_list.svg',
  },
  {
    label: pages.aiAnalyses,
    class: classes.nhb,
    route: '/analisi-ai',
    icon_path: 'assets/imgs/icons/analisi_ai.svg',
  },
];

export const navigationItemsWithPatient: NavigationItem[] = [
  {
    label: pages.calendar,
    class: classes.nhb,
    route: '/calendario',
    icon_path: 'assets/imgs/icons/calendario.svg',
  },
  {
    label: pages.patients_list,
    class: classes.nhb,
    route: '/pazienti',
    icon_path: 'assets/imgs/icons/pazienti.svg',
  },
  {
    label: 'Patient Name',
    class: classes.nhb,
    route: '',
    icon_path: 'assets/imgs/icons/user-yellow.svg',
  },
  {
    label: pages.registry,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/identification.svg',
  },
  {
    label: pages.medicalHistory,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/document_text.svg',
  },
  {
    label: pages.lifeLine,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/arrow_long_right.svg',
  },
  {
    label: pages.documents,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/document.svg',
  },
  {
    label: pages.aiFeatures,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/sparkles.svg',
  },
  {
    label: pages.modules,
    class: classes.nhb,
    route: '',
    icon_path: 'assets/imgs/icons/documenti.svg',
  },
  {
    label: pages.invoices,
    class: classes.nhb,
    route: '',
    icon_path: 'assets/imgs/icons/fatture.svg',
  },
  {
    label: pages.aiAnalyses,
    class: classes.nhb,
    route: '/analisi-ai',
    icon_path: 'assets/imgs/icons/analisi_ai.svg',
  },
];

export const navigationItemsWithPatientAndInterview: NavigationItem[] = [
  {
    label: pages.calendar,
    class: classes.nhb,
    route: '/calendario',
    icon_path: 'assets/imgs/icons/calendario.svg',
  },
  {
    label: pages.patients_list,
    class: classes.nhb,
    route: '/pazienti',
    icon_path: 'assets/imgs/icons/pazienti.svg',
  },
  {
    label: 'Patient Name',
    class: classes.nhb,
    route: '',
    icon_path: 'assets/imgs/icons/user-yellow.svg',
  },
  {
    label: pages.interviewDetails,
    class: classes.hnb,
    route: '',
    icon_path: 'assets/imgs/icons/document_text.svg',
  },
  {
    label: pages.registry,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/identification.svg',
  },
  {
    label: pages.medicalHistory,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/document_text.svg',
  },
  {
    label: pages.lifeLine,
    class: classes.nhnb,
    route: '',
    icon_path: 'assets/imgs/icons/arrow_long_right.svg',
  },
  {
    label: pages.documents,
    class: classes.nhnb,
    route: '/documenti',
    icon_path: 'assets/imgs/icons/document.svg',
  },
  {
    label: pages.aiFeatures,
    class: classes.nhnb,
    route: '/funzioni-ai',
    icon_path: 'assets/imgs/icons/sparkles.svg',
  },
  {
    label: pages.modules,
    class: classes.nhb,
    route: '/documenti',
    icon_path: 'assets/imgs/icons/documenti.svg',
  },
  {
    label: pages.invoices,
    class: classes.nhb,
    route: '/fatture',
    icon_path: 'assets/imgs/icons/fatture.svg',
  },
  {
    label: pages.aiAnalyses,
    class: classes.nhb,
    route: '/analisi-ai',
    icon_path: 'assets/imgs/icons/analisi_ai.svg',
  },
];
